import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Slider from "@material-ui/core/Slider";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";

const useStyles = makeStyles((theme) => ({
  audioWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "4px 8px",
    minWidth: 220,
    maxWidth: 320,
  },
  slider: {
    flex: 1,
    color: theme.palette.primary.main,
  },
  time: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    minWidth: 36,
    textAlign: "right",
  },
}));

const formatTime = (secs) => {
  if (isNaN(secs)) return "0:00";
  const m = Math.floor(secs / 60);
  const s = Math.floor(secs % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
};

const Audio = ({ url }) => {
  const classes = useStyles();
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handlePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setPlaying(!playing);
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    if (audio) setCurrentTime(audio.currentTime);
  };

  const handleLoadedMetadata = () => {
    const audio = audioRef.current;
    if (audio) setDuration(audio.duration);
  };

  const handleEnded = () => {
    setPlaying(false);
    setCurrentTime(0);
    if (audioRef.current) audioRef.current.currentTime = 0;
  };

  const handleSliderChange = (e, value) => {
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = value;
      setCurrentTime(value);
    }
  };

  return (
    <div className={classes.audioWrapper}>
      <audio
        ref={audioRef}
        src={url}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={handleEnded}
        preload="metadata"
      />
      <IconButton size="small" onClick={handlePlayPause}>
        {playing ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>
      <Slider
        className={classes.slider}
        min={0}
        max={duration || 0}
        value={currentTime}
        onChange={handleSliderChange}
        step={0.1}
      />
      <span className={classes.time}>
        {playing || currentTime > 0
          ? formatTime(currentTime)
          : formatTime(duration)}
      </span>
    </div>
  );
};

export default Audio;
